import { getTransactionStatus } from '@features/transactions/helper';

import AmountProgressBar from './AmountProgressBar';
import AmountTag from './AmountTag';

interface TransactionAmountProps {
  status: string;
  settlementStatus: string;
  amount: string;
  paidAmount: string;
  splitPayment: boolean;
  isDisabled: boolean;
  id: string;
  showTooltip?: boolean;
}

const TransactionAmount = ({
  status,
  settlementStatus,
  amount,
  paidAmount,
  splitPayment,
  isDisabled,
  id,
  showTooltip
}: TransactionAmountProps) => {
  if (
    status === 'processing' &&
    settlementStatus === '' &&
    splitPayment &&
    Number(paidAmount) < Number(amount)
  ) {
    // progress bar
    return (
      <AmountProgressBar
        amount={Number(amount)}
        paidAmount={Number(paidAmount)}
        isSplitPayment={splitPayment}
        isDisabled={isDisabled}
        id={id}
        showTooltip={showTooltip}
      />
    );
  }
  return (
    <AmountTag
      status={getTransactionStatus(status, settlementStatus)}
      amount={amount}
      isSplitPayment={splitPayment}
      isDisabled={isDisabled}
      id={id}
    />
  );
};

export default TransactionAmount;
